const reviews = [
  {
    id: 1,
    image: '/images/reviews-gallery/review-garage.jpg',
    quote: "Aditya Electrical Projects completed the internal electrical works for our towers at Assotech Ltd. The team was professional and delivered to schedule.",
    name: "Rajesh Kumar (Director, GrihPravesh)"
  },
  {
    id: 2,
    image: '/images/reviews-gallery/review-kitchen.jpg',
    quote: "We engaged Aditya Electrical Projects for major electrical packages at Assotech projects — excellent coordination and workmanship throughout.",
    name: "Rajeev Srivastava (Director, Assotech)"
  },
  {
    id: 3,
    image: '/images/reviews-gallery/review-decking.jpg',
    quote: "Aarza Square's external and internal electrical works were handled efficiently by the team; great attention to detail and site discipline.",
    name: "Sanjay Kanojiya (General Manager, Aarza)"
  },
  {
    id: 4,
    image: '/images/reviews-gallery/review-consumer-unit.jpg',
    quote: "For the Lotus 300 (3 C Company) site Aditya Electrical Projects completed high-side installations reliably and with good communication.",
    name: "Sandeep Agarwal (General Manager, 3C)"
  },
  {
    id: 5,
    image: '/images/reviews-gallery/review-garage.jpg',
    quote: "Bhavya Creators' substation and electrical scope was executed professionally — the team showed strong technical capability.",
    name: "Mohit Malhotra (General Manager, Bhavya Architecture)"
  },
  {
    id: 6,
    image: '/images/reviews-gallery/review-kitchen.jpg',
    quote: "High-side and low-side works at AIIMS were completed safely and on time. We appreciated the compliance and testing documentation provided.",
    name: "Sanjeev Kumar (General Manager, AIIMS)"
  },
  {
    id: 7,
    image: '/images/reviews-gallery/review-decking.jpg',
    quote: "Aditya Electrical Projects carried out the electrical installation at our Smart World site with minimal disruption and good quality standards.",
    name: "Rajiv Kumar (General Manager, Sam India)"
  },
];

export default reviews;